'use client';
import React from 'react';
import handleChat from '~/utils/handle-chat';
import Styles from './chat-link.module.scss';
import { sendTealiumEvent } from '~/utils/tealium';
import { EVENT_WMAP_ORDER_CHAT_CLICK } from '~/constant/constants';
import { useChat } from '@mfrm/design-library';
interface ISleepExpertProps {
  label: string;
  id: string;
  styleClass: string;
  eventDescription?: string;
  enableMSChat?: boolean;
}
const ChatLink: React.FC<ISleepExpertProps> = ({
  label,
  id,
  styleClass,
  eventDescription,
  enableMSChat,
}) => {
  const eventData = {
    event: 'chat-widget-initiated',
    event_type: 'chat_click',
    event_category: 'chat',
    event_action: eventDescription || EVENT_WMAP_ORDER_CHAT_CLICK,
    event_label: 'chat engagement',
    event_noninteraction: 'false',
  };

  const chat = useChat();
  const callUtag = () => {
    sendTealiumEvent(eventData);
  };
  const handleChatClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    sendTealiumEvent(eventData);
    if (enableMSChat) {
      chat.setOpen();
    } else {
      handleChat();
    }
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    handleChatClick(e);
  };
  return (
    <>
      <a
        id={id}
        onClick={handleLinkClick}
        className={`${styleClass} ${Styles.desktopLink}`}
        href="#"
      >
        {label}
      </a>
      <a
        id={`${id}-mobile`}
        onClick={callUtag}
        href="http://mattressfirm.com/"
        target="_blank"
        rel="noopener noreferrer"
        className={`${styleClass} ${Styles.mobileLink}`}
      >
        {label}
      </a>
    </>
  );
};

export default ChatLink;
